import { useRecoilCallback } from 'recoil';
import { useExecutePreMount } from '../../../hooks/useExecutePreMount';
import { csChangeSettingWithId } from '../../../store/CsSettingState';
import ContentsDispatcher from './ContentsDispatcher';
import CsElevation from '../../crosssection/contents/Elevation';
import { useDisplayOperationRecoilState } from '../../../hooks/useDisplayOperation';

const ElevationDispatcher = (props) => {
  const { contents } = props;

  const [, setCsState] = useDisplayOperationRecoilState(
    {
      path: CsElevation.CS_NAME,
      key: 'value',
      function: 'setContentsSettings',
    },
    csChangeSettingWithId(CsElevation.CS_NAME)
  );

  const dispatcher = useRecoilCallback(
    ({ snapshot }) =>
      async (action) => {
        const release = snapshot.retain();

        try {
          if (action.type === 'SET_CONTENTS_VISIBLE') {
            // Mapの標高要素の変更を断面図のステートに伝搬させる
            const { name, visible } = action.payload;

            const csState = await snapshot.getLoadable(csChangeSettingWithId(CsElevation.CS_NAME))
              .contents;

            const newCsState = { ...csState, [name]: visible };
            setCsState(newCsState);
          } else if (action.type === 'RESET_CONTENTS_VISIBLE') {
            // Mapの標高要素の変更を断面図のステートに伝搬させる
            setCsState(action.payload);
          }
        } finally {
          release();
        }
      },
    []
  );

  useExecutePreMount(() => {
    contents.setElevationDispatcher(dispatcher);
  });

  return <ContentsDispatcher {...props} />;
};

export default ElevationDispatcher;
